/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setThree.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import * as THREE from 'three';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const canvas = document.getElementById('canvas');
const path = "/crewmap_cms/wp-content/themes/crewmap/assets/";
const svgLoader = new SVGLoader();

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function setThree() {

    let window_W, window_H, document_body_cW, document_body_cH // ウィンドウ、ドキュメントサイズ
    let scene, camera, renderer // シーン、カメラ、レンダラー
    let fov, fovRad, distance // カメラの視野角
    let boat = new THREE.Group(); // ボート
    let boat_shadow = new THREE.Group(); // ボートの影
    let boat_box, boat_size, boat_center // svg収納, サイズ, 中心
    let wavegroup = new THREE.Group(); // 波
    let inertialScroll = 0; // 慣性スクロールの値
    let inertialScrollPercent = 0; // 慣性スクロールのパーセント値(0~100)
    let sceneArray = []; // シーンの配列
    let js_sceneAll = document.querySelectorAll('.--js_scene'); // シーンの要素
    let js_scene_scroll; // シーンのスクロール値
    let animationScripts = []; // アニメーションの配列(pc)
    let animationScriptsSP = []; // アニメーションの配列(sp)
    let animationProps = { duration: 5, ease: "none", repeat: -1, yoyo: true, } // GSAPアニメーションのプロパティ

    window.addEventListener('load', () => {
        init();
        createWave();
        createBoat();
        const intervalID = setInterval(function () {
            if (waveFlag === true && boatFlag === true) {
                clearInterval(intervalID);
                renderScene();
                animationBoat();
            }
        }, 50);
    });

    /**
     * 初期設定
     */
    function init() {

        //画面サイズ取得
        window_W = window.innerWidth;
        window_H = window.innerHeight;

        //ドキュメントサイズ取得
        document_body_cW = document.body.clientWidth;
        document_body_cH = document.body.clientHeight;

        //カメラ作成
        fov = 100; //カメラの視野角
        fovRad = (fov / 2) * (Math.PI / 180); // 視野角をラジアンに変換
        distance = (window_H / 2) / Math.tan(fovRad); // カメラ距離を求める
        camera = new THREE.PerspectiveCamera(fov, window_W / window_H, 0.1, 1000); // カメラを作成

        //シーン作成
        scene = new THREE.Scene();

        //レンダラー作成
        renderer = new THREE.WebGLRenderer({ alpha: true });
        renderer.setClearColor(0x000000, 0);
        renderer.setSize(window_W, window_H);
        renderer.setPixelRatio(window.devicePixelRatio);

        //レンダラーをDOMに追加
        canvas?.appendChild(renderer.domElement);

        //リサイズイベント
        let timer = false;
        function resizeEvent() {
            let resize_width = window.innerWidth;
            if (window_W != resize_width) {
                timer !== false && clearTimeout(timer);
                timer = setTimeout(function () {
                    resizeWindow();
                    window_W = resize_width;
                }, 100);
            }
        }
        window.addEventListener("orientationchange", resizeEvent);
        window.addEventListener("resize", resizeEvent);
    }

    /**
     * 三角形を作成
     */
    function triangles() {
        let group = new THREE.Group();
        let triangle = new THREE.Shape();
        //高さ45px, 底辺45pxの三角形を作成
        triangle.moveTo(0, 0);
        triangle.lineTo(160, 0);
        triangle.lineTo(80, 45);
        triangle.lineTo(0, 0);

        //３つ並べる
        for (let i = 0; i < 3; i++) {
            let geometry = new THREE.ShapeGeometry(triangle);
            let material = new THREE.MeshBasicMaterial({ color: 0xFFFFFF, side: THREE.FrontSide, depthWrite: false, opacity: 0.3, transparent: true });
            let mesh = new THREE.Mesh(geometry, material);
            mesh.position.x = 155 * i;
            animationScripts.push(gsap.to(mesh.position, { x: 155 * i + 70, ...animationProps }));
            group.add(mesh);
        }

        return group;
    }

    /**
     * 波を作成
     */
    let waveFlag = false;
    function createWave() {
        let pos_top, pos_right, pos_left
        pos_top = (window_H / 2);
        pos_right = (2560) - 2560 / 2;
        pos_left = (2560 / 2);
        for (let i = 0; i < 12; i++) {
            let wave = triangles();
            if (i == 0) {
                wave.position.x = pos_left * -1;
                wave.position.y = pos_top * 1;
            }
            if (i == 1) {
                wave.position.x = pos_left / 2 * -1;
                wave.position.y = pos_top * -2;
            }
            if (i == 2) {
                wave.position.x = pos_left / 4 * -1;
                wave.position.y = pos_top * -1;
            }
            if (i == 3) {
                wave.position.x = pos_left / 8 * -1;
                wave.position.y = pos_top * -4.2;
            }
            if (i == 4) {
                wave.position.x = pos_right;
                wave.position.y = pos_top * -1.5;
            }
            if (i == 5) {
                wave.position.x = pos_right / 2;
                wave.position.y = pos_top * -3.8;
            }
            if (i == 6) {
                wave.position.x = pos_right / 4;
                wave.position.y = pos_top * 1.5;
            }
            if (i == 7) {
                wave.position.x = pos_right / 8;
                wave.position.y = pos_top * -2.8;
            }
            if (i == 8) {
                wave.position.x = pos_left * -0.7;
                wave.position.y = pos_top * -0.5;
            }
            if (i == 9) {
                wave.position.x = pos_left * -1;
                wave.position.y = pos_top * -2.5;
            }
            if (i == 10) {
                wave.position.x = pos_right * 0.7;
                wave.position.y = pos_top * 0.5;
            }
            if (i == 11) {
                wave.position.x = pos_left * -1.5;
            }
            wavegroup.add(wave);
        }
        scene.add(wavegroup);
        waveFlag = true;
    }

    /**
    * ボートを作成
    */
    let boatFlag = false;
    function createBoat() {
        let svgSrc = path + "/images/material.svg";

        svgLoader.load(
            svgSrc,
            function (data) {
                let paths = data.paths;
                for (let i = 0; i < paths.length; i++) {
                    let path = paths[i];
                    let material01 = new THREE.MeshBasicMaterial({ color: path.color, side: THREE.DoubleSide, depthWrite: false, transparent: true });
                    let material02 = new THREE.MeshBasicMaterial({ color: 0x000000, side: THREE.DoubleSide, depthWrite: false, opacity: 0.15, transparent: true });
                    let shapes = SVGLoader.createShapes(path);
                    for (let j = 0; j < shapes.length; j++) {
                        let shape = shapes[j];
                        let geometry = new THREE.ShapeGeometry(shape);
                        let mesh = new THREE.Mesh(geometry, material01);
                        let mesh_shadow = new THREE.Mesh(geometry, material02);
                        animationScripts.push(
                            gsap.to(mesh.position, { x: 20, y: -10, ...animationProps }),
                            gsap.to(mesh_shadow.position, { x: -20, y: 10, ...animationProps })
                        );
                        boat.add(mesh);
                        boat_shadow.add(mesh_shadow);
                    }
                }
                boat_box = new THREE.Box3().setFromObject(boat);
                boat_size = boat_box.getSize(new THREE.Vector3()).length();
                boat_center = boat_box.getCenter(new THREE.Vector3());
                boat.size, boat_shadow.size = boat_size;
                boat.position.z = 2;
                boat_shadow.position.z = 1;
            }
        );

        scene.add(boat, boat_shadow);
        boatFlag = true;
    }

    /**
     * ボートのアニメーション
     */
    function animationBoat() {
        const loadingAnimation = () => {
            setTimeout(function () {
                let option = { duration: 4, ease: "power4.out" }
                if (waveFlag === true && boatFlag === true) {
                    gsap.set(boat.position, { y: -boat_center.y * -0.5 });
                    gsap.set(boat_shadow.position, { y: (-boat_center.y * -0.5) - 27 });
                    gsap.to(boat.position, { y: -boat_center.y, ...option });
                    gsap.to(boat_shadow.position, { y: -boat_center.y - 27, ...option });
                }
            }, 250);
        }

        if (location.hash == "") {
            loadingAnimation()
        }
    }

    /**
     *  xとyの線形補完
     */
    function lerp(x, y, a) {
        // return (1 - a) * x + a * y;
        return x + (y - x) * easeOutQuad(a);
    }

    /**
     * パーセントのスケール
     */
    function scalePercent(start, end) {
        return (inertialScrollPercent - start) / (end - start);
    }

    /**
     * イージング
     */
    function easeOutQuad(x) {
        let t = x; const b = 0; const c = 1; const d = 1;
        return -c * (t /= d) * (t - 2) + b;
    }

    /**
     * シーンまでの距離を計算
     */
    function setSceneScrollPercent() {
        js_sceneAll.forEach((js_scene) => {
            js_scene_scroll = js_scene.getBoundingClientRect().top + window.pageYOffset;
            sceneArray.push(Number(((js_scene_scroll / document_body_cH) * 100).toFixed(0)));
        });
    }

    /**
     * シーンに応じたアニメーションを登録
     */
    function setAnimationScriptss() {
        //アニメーションシーンの登録(PC)
        animationScripts = [
            {
                start: 0, end: sceneArray[0],
                func: () => {
                    //カメラ
                    camera.position.x = lerp(0, 0, scalePercent(0, sceneArray[0]));
                    camera.position.y = lerp(-distance, -distance, scalePercent(0, sceneArray[0]));
                    camera.position.z = lerp(distance, 700, scalePercent(0, sceneArray[0]));
                    camera.rotation.z = lerp(0, 0, scalePercent(0, sceneArray[0]));
                    //ボート
                    boat.position.y = lerp(-boat_center.y, -boat_center.y * 1.5, scalePercent(0, sceneArray[0]));
                    boat.position.x = lerp(-boat_center.x, -boat_center.x * 1.5, scalePercent(0, sceneArray[0]));
                    boat.rotation.z = lerp(0, Math.PI / -18, scalePercent(0, sceneArray[0]));
                    //ボート影
                    boat_shadow.position.y = lerp(-boat_center.y - 27, -boat_center.y * 1.5 - 27, scalePercent(0, sceneArray[0]));
                    boat_shadow.position.x = lerp(-boat_center.x + 180, -boat_center.x * 1.5 + 180, scalePercent(0, sceneArray[0]));
                    boat_shadow.rotation.z = lerp(0, Math.PI / -18, scalePercent(0, sceneArray[0]));
                    //波
                    wavegroup.position.y = lerp(0, 0, scalePercent(0, sceneArray[0]));
                    wavegroup.position.x = lerp(0, 0, scalePercent(0, sceneArray[0]));
                    wavegroup.rotation.z = lerp(0, 0, scalePercent(0, sceneArray[0]));
                }
            },
            {
                start: sceneArray[0], end: sceneArray[1],
                func: () => {
                    //カメラ
                    camera.position.x = lerp(0, 0, scalePercent(sceneArray[0], sceneArray[1]));
                    camera.position.y = lerp(-distance, -distance, scalePercent(sceneArray[0], sceneArray[1]));
                    camera.position.z = lerp(700, 1000, scalePercent(sceneArray[0], sceneArray[1]));
                    camera.rotation.z = lerp(0, Math.PI / -2.25, scalePercent(sceneArray[0], sceneArray[1]));
                    //ボート
                    boat.position.y = lerp(-boat_center.y * 1.5, -boat_center.y * 3, scalePercent(sceneArray[0], sceneArray[1]));
                    boat.position.x = lerp(-boat_center.x * 1.5, -boat_center.x * 1.5, scalePercent(sceneArray[0], sceneArray[1]));
                    boat.rotation.z = lerp(Math.PI / -18, Math.PI / 18, scalePercent(sceneArray[0], sceneArray[1]));
                    //ボート影
                    boat_shadow.position.y = lerp(-boat_center.y * 1.5 - 27, -boat_center.y * 3 - 180, scalePercent(sceneArray[0], sceneArray[1]));
                    boat_shadow.position.x = lerp(-boat_center.x * 1.5 + 180, -boat_center.x * 1.5 + 27, scalePercent(sceneArray[0], sceneArray[1]));
                    boat_shadow.rotation.z = lerp(Math.PI / -18, Math.PI / 18, scalePercent(sceneArray[0], sceneArray[1]));
                    //波
                    wavegroup.position.y = lerp(0, boat_center.y, scalePercent(sceneArray[0], sceneArray[1]));
                    wavegroup.position.x = lerp(0, boat_center.y, scalePercent(sceneArray[0], sceneArray[1]));
                    wavegroup.rotation.z = lerp(0, Math.PI / -2.25, scalePercent(sceneArray[0], sceneArray[1]));
                }
            },
            {
                start: sceneArray[1], end: sceneArray[2],
                func: () => {
                    //カメラ
                    camera.position.x = lerp(0, 0, scalePercent(sceneArray[1], sceneArray[2]));
                    camera.position.y = lerp(-distance, -distance * 2, scalePercent(sceneArray[1], sceneArray[2]));
                    camera.position.z = lerp(1000, 1000, scalePercent(sceneArray[1], sceneArray[2]));
                    //ボート
                    boat.position.y = lerp(-boat_center.y * 3, -boat_center.y * 4, scalePercent(sceneArray[1], sceneArray[2]));
                    //ボート影
                    boat_shadow.position.y = lerp(-boat_center.y * 3 - 180, -boat_center.y * 4 - 60, scalePercent(sceneArray[1], sceneArray[2]));
                }
            },
            {
                start: sceneArray[2], end: sceneArray[3],
                func: () => {
                    //カメラ
                    camera.position.x = lerp(0, boat_center.y * -0.5, scalePercent(sceneArray[2], sceneArray[3]));
                    camera.position.y = lerp(-distance * 2, (-distance + -boat_center.y * 2.5), scalePercent(sceneArray[2], sceneArray[3]));
                    camera.position.z = lerp(1000, distance / 20, scalePercent(sceneArray[2], sceneArray[3]));
                }
            },
        ]
        //アニメーションシーンの登録(SP)
        animationScriptsSP = [
            {
                start: 0, end: sceneArray[0],
                func: () => {
                    //カメラ
                    camera.position.y = lerp(-distance, -distance * 1.5, scalePercent(0, sceneArray[0]));
                    camera.position.z = lerp(distance * 2, 1000, scalePercent(0, sceneArray[0]));
                    //ボート
                    boat.position.y = lerp(-boat_center.y, -boat_center.y * 1.5, scalePercent(0, sceneArray[0]));
                    boat.position.x = lerp(-boat_center.x, -boat_center.x * 1.4, scalePercent(0, sceneArray[0]));
                    boat.rotation.z = lerp(0, Math.PI / -18, scalePercent(0, sceneArray[0]));
                    //ボート影
                    boat_shadow.position.y = lerp(-boat_center.y - 27, -boat_center.y * 1.5 - 27, scalePercent(0, sceneArray[0]));
                    boat_shadow.position.x = lerp(-boat_center.x + 180, -boat_center.x * 1.4 + 180, scalePercent(0, sceneArray[0]));
                    boat_shadow.rotation.z = lerp(0, Math.PI / -18, scalePercent(0, sceneArray[0]));
                }
            },
            {
                start: sceneArray[0], end: sceneArray[1],
                func: () => {
                    //カメラ
                    camera.position.y = lerp(-distance * 1.5, -distance * 3, scalePercent(sceneArray[0], sceneArray[1]));
                    camera.position.z = lerp(1000, 1000, scalePercent(sceneArray[0], sceneArray[1]));
                    //ボート
                    boat.position.y = lerp(-boat_center.y * 1.5, -boat_center.y * 2, scalePercent(sceneArray[0], sceneArray[1]));
                    boat.position.x = lerp(-boat_center.x * 1.4, -boat_center.x, scalePercent(sceneArray[0], sceneArray[1]));
                    boat.rotation.z = lerp(Math.PI / -18, 0, scalePercent(sceneArray[0], sceneArray[1]));
                    //ボート影
                    boat_shadow.position.y = lerp(-boat_center.y * 1.5 - 27, -boat_center.y * 2 - 27, scalePercent(sceneArray[0], sceneArray[1]));
                    boat_shadow.position.x = lerp(-boat_center.x * 1.4 + 180, -boat_center.x + 180, scalePercent(sceneArray[0], sceneArray[1]));
                    boat_shadow.rotation.z = lerp(Math.PI / -18, 0, scalePercent(sceneArray[0], sceneArray[1]));
                }
            },
            {
                start: sceneArray[1], end: sceneArray[2],
                func: () => {
                    //カメラ
                    camera.position.y = lerp(-distance * 3, -distance / 0.5, scalePercent(sceneArray[1], sceneArray[2]));
                    camera.position.z = lerp(1000, distance, scalePercent(sceneArray[1], sceneArray[2]));
                }
            },
        ]
    }

    /**
     * スクロール値に応じたアニメーションを呼び出し
     */
    function playScrollAnimations() {
        setSceneScrollPercent();
        setAnimationScriptss();
        let script = window.matchMedia("(min-width: 835px)").matches ? animationScripts : animationScriptsSP;
        script.forEach((script) => {
            if (inertialScrollPercent >= script.start && inertialScrollPercent < script.end) {
                script.func();
            }
        });
    }

    /**
     * 慣性スクロールのためにスクロール値を取得する
     */
    let delayTime = window.matchMedia("(min-width: 835px)").matches ? 0.03 : 0.01;
    function setScrollPercent() {
        inertialScroll += ((document.documentElement.scrollTop || document.body.scrollTop) - inertialScroll) * delayTime;
        inertialScrollPercent = (inertialScroll / ((document.documentElement.scrollHeight || document.body.scrollHeight) - document.documentElement.clientHeight) * 100).toFixed(2);
    }

    /**
     * リサイズ時の処理
     */
    function resizeWindow() {
        window_W = window.innerWidth;
        window_H = window.innerHeight;
        document_body_cW = document.body.clientWidth;
        document_body_cH = document.body.clientHeight;
        renderer.setSize(window_W, window_H);
        camera.aspect = window_W / window_H;
        distance = (window_H / 2) / Math.tan(fovRad);
        camera.updateProjectionMatrix();
        playScrollAnimations();
        renderScene();
    }

    /**
     * レンダリング
     */
    function renderScene() {
        renderer.render(scene, camera);
        setScrollPercent();
        window.requestAnimationFrame(renderScene);
        playScrollAnimations();
    }

}

/**
 * 書き出し
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setThree };